<div class="not_found">
  <img src="./assets/images/page_not_found.png">
  <button type="button" class="go-back-btn" (click)="goHome()">{{language.GO_TO_HOME_PAGE}}</button>
</div>
